import React from "react";
import TokenTransferStepButton from "../../TokenTransferStepButton";
import { PhoneNumber, VerificationCode } from "@/libs/apis/onboarding/mfa";
import EnterVerificationCode from "@/src/components/cards/components/ProductCard/components/ProductCardFooter/components/TokenTransferModule/TokenTransferModal/components/steps/VerifyAccount/SecurePhoneNumber/components/EnterVerificationNumber";

export type VerificationCodeFormProps = {
  onSuccess?: (
    data: VerificationCode & {
      phoneNumber: PhoneNumber;
    },
  ) => Promise<void>;
};

const VerificationCodeForm: React.FC<VerificationCodeFormProps> = ({
  onSuccess,
}) => {
  return (
    <EnterVerificationCode
      onSubmit={async (data) => {
        onSuccess && (await onSuccess(data));
      }}
    >
      <TokenTransferStepButton>Continue</TokenTransferStepButton>
    </EnterVerificationCode>
  );
};

export default VerificationCodeForm;
